<template>
  <div v-if="configMap !== null">
    <template v-if="configMap.searchDataPosition === 'onTop' && configMap.searchField">
      <vue-simple-suggest
          v-model="chosen"
          :destyled="true"
          :display-attribute="searchField"
          :filter-by-query="true"
          :list="getSuggestionList"
          :max-suggestions="5"
          :placeholder="$t('DATA_FROM_SEARCH')"
          :styles="autoCompleteStyle"
          :value-attribute="searchField"
          class="top-search-bar"
          mode="select"
          @select="focusOnLocationSelected"
      >
        <div slot="suggestion-item" slot-scope="{ suggestion }" class="suggestionItem">
          <span>{{ suggestion.properties[configMap.searchField] }}</span>
        </div>
      </vue-simple-suggest>
    </template>
    <div id="flex-wrapper">
      <SideBar
          id="sidebar-1"
          :sideopened="sideopened"
          shadow
          title="Sidebar"
          @toggle-sidebar="toggleSideBar"
      >
        <div>
          <ul v-if="sideopened" class="list-group list-group-flush">
            <li
                v-for="(value, key) in chosen.properties"
                :key="key"
                class="fieldItem"
                style="list-style-type: none"
            >
              <i class="lighter">{{ key }}</i
              >: {{ value }}
            </li>
          </ul>
        </div>
      </SideBar>
      <transition>
        <div id="mapContainer">
          <l-map
              ref="map"
              :options="mapOptions"
              style="height: 100%"
              @ready="doSomethingOnReady()"
          >
            <template v-if="configMap.activeLocateMe">
              <l-control
                  :title="$t('LOCATE_ME')"
                  class="locate-me pointer">
                <div @click="locateme">
                  <img src="../assets/target.png"/>
                </div>
              </l-control>
            </template>
            <transition name="fade">
              <l-circle
                  v-if="showCircle"
                  :lat-lng="circleLocateme.center"
                  :radius="circleLocateme.radius"
              >
              </l-circle>
            </transition>

            <template v-if="configMap.activeGeoSearch">
              <v-geosearch
                  :options="geosearchOptions"
                  @click="hideSearchData"
              ></v-geosearch>
            </template>
            <l-control :title="$t('DATA_SEARCH')" class="search-data" position="topleft">
              <template
                  v-if="configMap.searchDataPosition === 'inside' && configMap.searchField"
              >
                <template v-if="showSearchData">
                  <vue-simple-suggest
                      v-model="chosen"
                      :destyled="true"
                      :display-attribute="searchField"
                      :filter-by-query="true"
                      :list="getSuggestionList"
                      :max-suggestions="5"
                      :placeholder="$t('DATA_FROM_SEARCH')"
                      :styles="autoCompleteStyle"
                      :value-attribute="searchField"
                      mode="select"
                      @blur="hideSearchData"
                      @select="focusOnLocationSelected"
                  >
                    <div
                        slot="suggestion-item"
                        slot-scope="{ suggestion }"
                        class="suggestionItem"
                    >
                      <span>{{ suggestion.properties[configMap.searchField] }}</span>
                    </div>
                  </vue-simple-suggest>
                </template>

                <template v-else>
                  <div @click="showSearchData = !showSearchData">
                    <img src="../assets/data.png"/>
                  </div>
                </template>
              </template>
            </l-control>
            <l-control-layers/>
            <l-tile-layer
                v-for="layer in displayedBasemaps"
                :key="layer.id"
                :attribution="buildAttribution(layer)"
                :name="layer.name"
                :url="layer.url"
                :visible="layer.visible"
                layer-type="base"
            />
            <template v-if="configMap.isGeojsonClustered">
              <v-marker-cluster v-if="geojsonLoaded">
                <l-geo-json
                    :geojson="geojson"
                    :options="optionsGeojson"
                    @click="clusterClick($event.layer.feature)"
                />
              </v-marker-cluster>
            </template>
            <template v-else>
              <l-geo-json
                  v-if="geojsonLoaded"
                  :geojson="geojson"
                  :options="optionsGeojson"
                  @click="clusterClick($event.layer.feature)"
              />
            </template>
          </l-map>
          <br/>
        </div>
      </transition>
    </div>
  </div>
  <div v-else>
    <div v-if="errorOnLoad"
         class="alert alert-warning"
         role="alert"
    >
      {{ $t('ALERT_WARNING') }}
    </div>
  </div>
</template>

<script>
import L, {latLng} from 'leaflet';
import {LCircle, LControl, LControlLayers, LGeoJson, LMap, LTileLayer,} from 'vue2-leaflet';
import VMarkerCluster from 'vue2-leaflet-markercluster';
import {OpenStreetMapProvider} from 'leaflet-geosearch';
import VGeosearch from 'vue2-leaflet-geosearch';
import VueSimpleSuggest from 'vue-simple-suggest';
import i18n from '@/plugins/i18n';
import SideBar from './sidebar';
import * as localConfig from '../data/config.json';
import 'leaflet-geosearch/assets/css/leaflet.css';
import 'vue-simple-suggest/dist/styles.css';

export default {
  components: {
    LMap,
    LTileLayer,
    LControlLayers,
    LGeoJson,
    VMarkerCluster,
    VGeosearch,
    VueSimpleSuggest,
    SideBar,
    LControl,
    LCircle,
  },
  name: 'Mappy',
  props: ['loading'],
  data: function () {
    return {
      map: null,
      chosen: '',
      sideopened: false,
      autoCompleteStyle: {
        vueSimpleSuggest: 'position-relative',
        inputWrapper: '',
        defaultInput: 'form-control',
        suggestions: 'position-absolute list-group z-10000',
        suggestItem: 'list-group-item',
      },
      mapOptions: {
        zoomSnap: 0.5,
        attributionControl: true
      },
      showSearchDataInsideMap: localConfig.showSearchDataInsideMap,
      geojson: null,
      enableTooltip: true,
      coordinates_lv95: [2515729, 1150364],
      geosearchOptions: {
        provider: new OpenStreetMapProvider(),
        autoClose: true,
        searchLabel: this.$t('SEARCH_ADRESS'),
      },
      circleLocateme: {
        center: latLng(47.41322, -1.0482),
        radius: 450,
      },
      showCircle: false,
      positionId: null,
      showSearchData: false,
      geojsonLoaded: false,
      geojsonData: {},
      configMap: null,
      toolsValidity: {
        long: true,
        lat: true,
        search: true,
        label: true,
      },
      errorOnLoad: false,
    };
  },
  methods: {
    buildAttribution(layer) {
      return '<a href="https://selfmap.ch" target="_blank">Selfmap.ch</a> | ' + layer.attribution
    },
    async getParentHostname() {
      return await new Promise((resolve, reject) => {
        const listener = (event) => {
          if (event.data && event.data.hostname) {
            window.removeEventListener('message', listener);
            resolve(event.data.hostname);
          }
        };
        window.addEventListener('message', listener);
        window.parent.postMessage('ask-hostname', '*');

        setTimeout(() => {
          window.removeEventListener('message', listener);
          reject(new Error('Parent did not respond with hostname'));
        }, 3000);
      });
    },
    doSomethingOnReady() {
      this.map = this.$refs.map.mapObject;

      if (this.geojson && this.map) {
        const layer = L.geoJSON(this.geojson);
        this.map.fitBounds(layer.getBounds(), {
          padding: [50, 50],
          maxZoom: 16
        });
      }
    },

    async fetchAllData() {
      let details;
      try {
        const urlParams = new URLSearchParams(window.location.search);
        const baseURI = process.env.VUE_APP_BASE_URL + '/back/api/fetch';
        const domain = await this.getParentHostname();
        const token = urlParams.get('token');
        const params = new URLSearchParams({domain, token});
        const response = await this.$http.get(`${baseURI}?${params.toString()}`);

        if (!response.data.geojsonData && !response.data.configMap) {
          this.geojsonLoaded = false;
          details = response.data;
          throw new Error('Something bad happened');
        } else {
          this.geojsonLoaded = true;
          this.geojson = response.data?.geojsonData;
          this.configMap = response.data?.configMap;
        }

        setTimeout(() => {
          this.$emit('stop-loading', false);
        }, 2000);
      } catch (error) {
        console.log(error, {details});
        console.log('error fetching data from server. Check the configuration, the server is launched');
        this.$emit('stop-loading', false);
        this.errorOnLoad = true;
      }

    },
    clusterClick(feature) {
      if (feature) {
        this.chosen = {...feature};
        this.sideopened = true;
      }
    },
    locateme() {
      const accessor = this;
      this.positionId = navigator.geolocation.getCurrentPosition(
          (pos) => {
            var crd = pos.coords;
            accessor.map.setView(latLng(crd.latitude, crd.longitude), 15);
            accessor.circleLocateme.center = latLng(crd.latitude, crd.longitude);
            accessor.showCircle = true;
            setTimeout(() => {
              accessor.showCircle = false;
            }, 1500);
          },
          (err) => {
            console.warn(`ERREUR (${err.code}): ${err.message}`);
            alert(`ERREUR (${err.code}): ${err.message}`);
          },
          {
            maximumAge: 0,
          }
      );
    },
    getSuggestionList() {
      return this.geojson.features;
    },
    focusOnLocationSelected(event) {
      if (event) {
        this.map.setView(
            latLng(event.geometry.coordinates[1], event.geometry.coordinates[0]),
            15
        );
        this.sideopened = true;
      } else {
        console.log('pas d\'entité sélectionnée');
      }
    },
    toggleSideBar(sideopen) {
      this.sideopened = sideopen;
    },

    hideSearchData() {
      this.showSearchData = false;
    },

    onEachFeatureFunction(feature, layer) {
      layer.bindTooltip(
          this.$t('LABEL_IS') + '<b>' + feature.properties[this.configMap.labelField] + '</b>',
          {
            permanent: false,
            sticky: true,
            interactive: true,
          }
      );
    },
  },
  mounted() {
    const paramsExist = this.$route.query.domain && this.$route.query.folderId;
    if (!paramsExist) {
      console.log('[front] No folderid in the URL, or no URL parent...');
    }
  },
  async created() {
    await this.fetchAllData();
  },
  computed: {
    optionsGeojson() {
      return {
        onEachFeature: this.configMap.labelField ? this.onEachFeatureFunction : null,
      };
    },
    searchField() {
      return this.configMap.searchField
          ? 'properties.' + this.configMap.searchField
          : 'properties.search';
    },

    displayedBasemaps() {
      return localConfig.basemaps
          .filter((bm) =>
              this.configMap.basemaps.includes(bm.id)
          )
          .map((bm, index) => {
            return {
              ...bm,
              visible: index === 0,
            };
          });
    },

  },

  watch: {
    configMap() {
      i18n.locale = (this.configMap) ? this.configMap.langue : i18n.locale;
    }
  }

};
</script>

<style lang="scss">
@import "~leaflet.markercluster/dist/MarkerCluster.css";
@import "~leaflet.markercluster/dist/MarkerCluster.Default.css";

#flex-wrapper {
  height: 100vh;
  width: 100%;
  display: flex;
  flex-direction: row;
}

#mapContainer {
  height: 100%;
  width: 100%;
  min-width: 65%;
  transition: width 2s;
}

.z-10000 {
  z-index: 10000;
  opacity: 0.8;
}

.list-group-item:hover {
  color: #007bff;
  //color: #fff;
}

.locate-me {
  background: #fff;
  padding: 0 0.5em;
  border: 1px solid #aaa;
  border-radius: 0.1em;
}

.pointer:hover {
  cursor: pointer;
}

.custom-control-watermark {
  font-size: 200%;
  font-weight: bolder;
  color: #aaa;
  text-shadow: #555;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 1.5s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
{
  opacity: 0;
}

.locate-me {
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.65);
  border-radius: 4px;
}

.locate-me img {
  width: 20px;
  height: 20px;
  opacity: 0.6;
  margin: 8px;
}

.search-data img {
  width: 30px;
  background-color: #fffffff0;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.65);
  border-radius: 4px;
  opacity: 0.8;
}

.fieldItem {
  font: 11px/1.5 "Segoe UI", Arial, Helvetica, sans-serif;
}

.lighter {
  color: #666666;
}
</style>
